module.exports = __webpack_public_path__ + "static/media/508shi.4fe3a0ca.jpg";